export default __webpack_public_path__ + "static/media/gwc-husd.abf436c2.png";